<template>
  <div v-if="barangay" class="row">
    <el-drawer title="" :visible.sync="showLeaderVotersList" direction="btt" :before-close="getSummary" size="90%"
        :destroy-on-close="true">
        <div class="row">
          <div class="col-md-3"></div>
          <div class="col-md-6">
            <barangay-voters-list :barangay="barangay" :leader="selected_leader" :show_status="true"></barangay-voters-list>
          </div>
        </div>
  
      </el-drawer>

    <div class="col-md-6" style="margin-bottom: 10px;">
      <el-card>
        <div>BARANGAY</div>
        <h5>{{ barangay.name }}</h5>
        <div style="font-weight: bold;" class="text-primary">
          <div style="font-size: 40px;">{{ barangay.voters_count }} VOTERS</div>
        <div style="font-size: 25px;"> {{
          barangay.leaders_count }} LEADERS</div>
        </div>
        <hr>
      </el-card>
    </div>
    <div class="col-md-2" style="margin-bottom: 10px;">
      <el-card v-if="barangay_data">
        <div style="text-align: center">
          <div class="text-primary" style="margin-bottom: 10px;">{{ barangay_data.validated }} validated voters out of {{
            barangay_data.total_voters }} total.</div>
          <el-progress type="dashboard" :stroke-width="10" :percentage="getPercentage(barangay_data, barangay_data.validated)"
            :color="getStatusLabel(barangay_data, barangay_data.validated)"></el-progress>
        </div>
      </el-card>
    </div>
    <div class="col-md-2" style="margin-bottom: 10px;">
      <el-card v-if="barangay_data">
        <div style="text-align: center;">
          <div class="text-info" style="margin-bottom: 10px">{{ barangay_data.voted }} votes cast out of {{ barangay_data.total_voters }}
            total voters.</div>
          <el-progress type="dashboard" :stroke-width="10" :percentage="getPercentage(barangay_data, barangay_data.voted)"
            :color="getStatusLabel(barangay_data, barangay_data.voted)"></el-progress>
        </div>

      
      </el-card>
    </div>
    <div class="col-md-2" style="margin-bottom: 10px;">
      <el-card v-if="barangay_data">
        <div style="text-align: center">
          <div class="text-danger" style="margin-bottom: 10px">{{ barangay_data.voted_straight }} voted straight out of {{
            barangay_data.total_voters }} total voters.</div>
          <el-progress type="dashboard"  :stroke-width="10" :percentage="getPercentage(barangay_data, barangay_data.voted_straight)"
            :color="getStatusLabel(barangay_data, barangay_data.voted_straight)"></el-progress>
        </div>
    
      </el-card>
    </div>
    <div class="col-md-12">
      <el-card style="margin-top: 20px;">
        <h5>Election Progress</h5>

        <div class="row">
          <div class="col-md-4" style="margin-bottom: 20px;">
            <label>Search by Leader</label>
            <el-select v-model="leader_id" filterable style="width: 100%" clearable>
              <el-option v-for="leader, i in leaders" :key="i" :value="leader.id" :label="leader.full_name"></el-option>
            </el-select>
          </div>
          <div class="col-md-8"> </div>

          <div v-for="item, i in collection" :key="i" style="margin-bottom: 20px;" class="col-md-4">
            <div class="bold" style="margin-bottom: 20px;">
              <a class="link" @click="handleViewLeaderVoters(item)">LEADER: {{ item.name.toUpperCase() }} <i class="fa fa-hand-pointer-o" aria-hidden="true"></i>              </a>
            </div>

            <div style="margin-bottom: 20px">
              <div class="text-primary" style="margin-bottom: 10px">{{ item.validated }} validated voter{{
                item.validated > 1 ? 's':'' }} out of {{ item.total_voters }} total.</div>
              <el-progress :text-inside="true" :stroke-width="20" :percentage="getPercentage(item, item.validated)"
                :color="getStatusLabel(item, item.validated)"></el-progress>
            </div>

            <div style="margin-bottom: 20px">
              <div class="text-info" style="margin-bottom: 10px">{{ item.voted }} vote{{ item.voted > 1 ? 's' : '' }} cast
                out of {{ item.total_voters }} total voter{{ item.total_voters > 1 ? 's' : '' }}.</div>
              <el-progress :text-inside="true" :stroke-width="26" :percentage="getPercentage(item, item.voted)"
                :color="getStatusLabel(item, item.voted)"></el-progress>
            </div>

            <div style="margin-bottom: 20px">
              <div class="text-danger" style="margin-bottom: 10px">{{ item.voted_straight }} voted{{ item.voted_straight
                > 1 ? '':'' }} straight out of {{ item.total_voters }} total voter{{ item.total_voters > 1 ? 's' : '' }}.
              </div>
              <el-progress :text-inside="true" :stroke-width="26" :percentage="getPercentage(item, item.voted_straight)"
                :color="getStatusLabel(item, item.voted_straight)"></el-progress>
            </div>
            <hr>
          </div>
        </div>
      </el-card>
    </div>

  </div>
</template>
<script>

import { db } from '@/firebase'

import { Barangay } from '@/resources/barangay'
import { Analytic } from '@/resources/analytics'

import BarangayLeadersList from './BarangayLeadersList.vue'
import BarangayVotersList from './BarangayVotersList.vue'

export default {
  components: { BarangayLeadersList, BarangayVotersList },
  props: ['barangay_id'],
  data() {
    return {
      leader_id: null,
      leaders: [],
      loading: false,
      barangay: null,
      showVoters: false,
      update: 0,
      collection: [],
      term: null,
      barangay_data: null,
      selected_leader: null,
      showLeaderVotersList: false,
      selected_barangay_id: null
    }
  },
  created: function () {
    this.selected_barangay_id = this.barangay_id || this.$route.params.id
    this.getLeaders()
    this.getBarangay()
    this.getNotifications()
  },
  watch: {
    leader_id: function () {
      this.getSummary()
    },
    term: function () {
      if (!this.term || this.term.length >= 3) this.getSummary()
    }
  },
  methods: {
    handleViewLeaderVoters(leader){
      this.showLeaderVotersList = true
      this.selected_leader = Object.assign({}, leader)
      this.selected_leader.id = leader.leader_id
    },
    handleManageVoters() {
      this.showVoters = true
    },
    getLeaders() {
      Barangay.leaders(this.selected_barangay_id, { term: this.term, per_page: 99999 }).then(result => {
        this.leaders = result.data.leaders
      })
        .catch(error => {

        }).finally(() => {
          this.loading = false
        })
    },
    getBarangay() {
      this.loading = true
      this.showVoters = false

      Barangay.show(this.selected_barangay_id).then(result => {
        this.barangay = result.data.barangay
        this.update += 1
        this.getSummary()
      })
        .catch(error => {

        }).finally(() => {
          this.loading = false
        })
    },
    getSummary() {
      this.showLeaderVotersList = false
      let params = { barangay_id: this.barangay.id, leader_id: this.leader_id }
      this.loading = true
      Analytic.getSummaryByLeaders(params)
        .then(result => {
          this.collection = result.data.leaders
          this.barangay_data = result.data.barangay_data
         
        })
        .catch(() => {

        }).finally(() => {
          this.loading = false
        })
    },
    getNotifications() {
      let path = 'notifications/dashboard'

      var ref = db.ref(path)
  
      ref
      .orderByChild('timestamp')
      .limitToLast(1) // Limit to the last record (the latest added)
      .on("child_added", (snapshot) => {
        const notification = snapshot.val();
        var notificationDate = new Date(notification.timestamp * 1000)
        var currentDate = new Date()
        const differenceSec = Math.abs(currentDate - notificationDate) / 1000;
        console.log("barangay notification")
        if (differenceSec < 3) {
          this.getSummary()
        }
      });
    },
  }
}
</script>
<style lang="scss"></style>